<div style="background-color : #4DB9A5; height: 100vh;">
    <div class="goBack" (click)="goBack()">
        <p>Home</p>
    </div>
    <div class="row no-gutters" style="width: 100%; height:  100%; ">
        <div class="col-12 col-md-6  d-flex justify-content-center align-items-center login_form_wrapper" >
            <div class="login_form_inner" id="exisiting_user" >
                <div class="d-flex justify-content-between align-items-center">
                    <img src="../../assets/images/yor_logo.png" width="50" height="50">
                    <p class="new_user" (click)="newUser()">New user? </p>
                </div>
                <p class="login_form_header">Sign in</p>
                <form class="form">
                    <div class="form-group">
                        <label for="login_email" class="login_label">Email address</label>
                        <input type="email"  placeholder="name@example.com" id="login_email" class="login_input form-control" name="login_email" [ngModel]="login.email" (ngModelChange)="changeLoginEmail($event)">
                    </div>
                    <div class="form-group">
                        <label for="login_password" class="login_label">Password</label>
                        <input type="password"  placeholder="•••••••" id="login_password" class="login_input form-control" name="login_password" [ngModel]="login.password" (ngModelChange)="changeLoginPassword($event)" style="letter-spacing: 5px; font-weight: 800; font-size: 20px;">
                    </div>
                    <br>
                    <div class="form-group">
                        <button (click)="loginSubmit()" class="login_sign_in" name="submit" type="submit">Sign in</button>
                    </div>
                </form>
                <br>
                <br>
                <p class="login_form_links" (click)=forgotPassword()>Forgot password?</p>
                <br>
                <p class="login_form_links" (click)="resendActivation()">Resend activation link!</p>
            </div>

            <!-- New User -->
            <div class="login_form_inner" id="new_user" style="display: none">
                <div class="d-flex justify-content-between align-items-center">
                    <img src="../../assets/images/yor_logo.png" width="50" height="50">
                    <p class="new_user" (click)="exisitingUser()">Exisiting user? </p>
                </div>
                <p class="login_form_header">Sign up</p>
                <form class="form">
                    <div class="form-group">
                        <input type="text"  placeholder="Name *" id="register_name" class="login_input form-control" name="register_name" [ngModel]="register.name" (ngModelChange)="changeRegisterName($event)">
                    </div>
                    <div class="form-group">
                        <input type="tel"  placeholder="Phone *" id="register_phone" class="login_input form-control" name="register_phone" [ngModel]="register.phone" (ngModelChange)="changeRegisterPhone($event)" maxLength="10"  >
                    </div>
                    <div class="form-group">
                        <input type="email"  placeholder="Email *" id="register_email" class="login_input form-control" name="register_email" [ngModel]="register.email" (ngModelChange)="changRegisterEmail($event)">
                    </div>
                    <div class="form-group">
                        <input type="password"  placeholder="•••••••" id="register_password" class="login_input form-control" name="register_password" [ngModel]="register.password" (ngModelChange)="changeRegisterPassword($event)" style="letter-spacing: 5px; font-weight: 800; font-size: 20px;">
                    </div>
                    <div class="form-group">
                        <input type="password"  placeholder="•••••••" id="register_confirm_password" class="login_input form-control" name="register_confirm_password" [ngModel]="register.password_confirmation" (ngModelChange)="changeRegisterPasswordConfirm($event)" style="letter-spacing: 5px; font-weight: 800; font-size: 20px;">
                    </div>
                    <div class="form-group">
                        <ul class="list-unstyled role_radio">
                          <li style="display: flex; font-size: 16px;"><input style="cursor: pointer; width: 18px; height: 18px;"type="radio" name="register_role" [value]="1" [ngModel]="register.role" (ngModelChange)="changeRegisterRole($event)" >&nbsp;Tenant</li>
                          <li style="display: flex; font-size: 16px;"><input style="cursor: pointer; width: 18px; height: 18px;"type="radio" name="register_role" [value]="2" [ngModel]="register.role" (ngModelChange)="changeRegisterRole($event)" >&nbsp;Owner</li>
                        </ul>
                    </div>
                    <br>
                    <div class="form-group">
                        <button (click)="registerValidation()" class="login_sign_in" name="submit" type="submit">Sign up</button>
                    </div>
                </form>
            </div>
        </div>
        <div class="d-none d-md-block col-md-6 login_greet_wrapper" >
            <div class="login_greet_inner">
                <img src="../../assets/images/loginbg.svg" style="margin-bottom: 40px; margin-right: 40px;" class="login_bg">
                <p class="login_greet_1">WELCOME TO</p>
                <p class="login_greet_2">YourOwnROOM</p>
        </div>
        </div>
        <div class="login_fail_msgs_wrapper" *ngIf="show_login_fail" data-aos="fade-left" data-aos-duration="1000">
            <p style="color: #981B1B; font-weight: 500;"><fa-icon [icon]="faTimesCircle" style="color: #EC4E2C ;margin-right: 20px;"></fa-icon>{{login_fail_msg}}</p>
        </div>
        <div class="login_pass_msgs_wrapper" *ngIf="show_login_pass" data-aos="fade-left" data-aos-duration="1000">
            <p style="color: #488373;"><fa-icon [icon]="faTimesCircle" style="color: #3db44b; margin-right: 20px;"></fa-icon>{{login_pass_msg}}</p>
        </div>
    </div>
</div>
